module.exports = __webpack_public_path__ + "static/netballers-d7c833c4953d492b4adbe1fb76a07c0d.jpg";